const translationOz ={
  navTel: "Ишонч телефони",
  email: "Электрон почта",
  home:"Бош сахифа",

  logo1: "Тиббиёт ходимларининг касбий ",
  logo2: "малакасини ривожлантириш маркази",
  logo3: "1 - ултратовуш диагностикаси кафедраси",

  kafedra: "Кафедра",
  kafedra1: "Тариҳ",
  kafedra2: "Профессор-ўқитувчилар",
  kafedra3: "Профессор-ўқитувчилар портфолиоси",
  kafedra4: "Маълумотнома",
  kafedra5: "Профессор-ўқитувчиларнинг илмий наширлари",

  xujjatlar: "Меъёрий ҳужжатлар",
  xujjatlar1: "Президент фармонлари",
  xujjatlar2: "Соғлиқни сақлаш вазирлиги буйруқлари",
  xujjatlar3: "Марказ буйруқлари",
  xujjatlar4: "Дастурлар",
  xujjatlar5: "Ишчи дастурлар",
  xujjatlar6: "Тақвим режа",
  xujjatlar7: "Дарс жадвали",

  faoliyat: "Фаолият",
  faoliyat1: "Ўқув фаолияти",
  faoliyat2: "Илмий фаолият",
  faoliyat3: "Услубий ташкилий фаолият",
  faoliyat4: "Кундалик фаолият",

  tinglovchilar: "Тингловчилар",
  tinglovchilar1: "Тингловчилар учун маълумотлар",
  tinglovchilar2: "Видео маърузалар",

  news: "Янгиликлар",
  news1: "Эълонлар",
  news2: "Конференсиялар",

  contact:"Алоқа",

  carsuelTittle: "1 - ултратовуш диагностикаси кафедраси",

  resultsTittle: "Узлуксиз таълим орқали миллат саломатлиги сари",
  resultsCardbody1: "йиллик шифокорлар таълимнинг тарихи",
  resultsCardbody2: "Вилоят филиаллари",
  resultsCardbody3: "Илмий даражали ходимлар",
  resultsCardbody4: "Юқори технологияли симуляция марказлари",
  resultsCardbody5: "Факультетлар",
  resultsCardbody6: "Академик",
  resultsCardbody7: "Илмий мактаблар",
  resultsCardbody8: "Кафедра илғор клиника ва марказларда",
  resultsCardbody9: "Фан номзоди ва докторлари",

  sitetittle: "Фойдали хаволалар",

  footerTittle: "Ижтимоий тармоқлар:",
  footer1: "Манзил:",
  footer2: "Авиасозлар коъчаси 29, Яшнабод тумни, Тошкент",
  footer3: "Иш вақти:",
  footer4: "Иш тартиби:",
  footer5: "Душанба - Жума, 8:30 - 14:30",
  footer6: "Дам олиш кунилари:",
  footer7: "Шанба, Якшанба",


  tarixtittle : "Тарих",
  tarix1: "Абдуфаттев Улуғбек Авазжанович",
  tarix2: "Юклаб олиш",
  tarix3: "Алимов Рустам Рахимович",
  tarix4: "Юклаб олиш",
  tarix5: "Жураев Захиджон Абдужалилович",
  tarix6: "Юклаб олиш",
  tarix7: "Захидова Нодира Ахмадовна",
  tarix8: "Юклаб олиш",
  tarix9: "Исроилова Махпуза Халиловна",
  tarix10: "Юклаб олиш",
  tarix11: "Қодиров Нодирбек Абдукахарович",
  tarix12: "Юклаб олиш",
  tarix13: "Қурбонов Фурқат Турдиевич",
  tarix14: "Юклаб олиш",
  tarix15: "Қурбонова Вусала Видадиевна",
  tarix16: "Юклаб олиш",
  tarix17: "Розихўжаева Гулнора Ахмедовна",
  tarix18: "Юклаб олиш",
  tarix19: "Хасанов Иззатилла Ғайбиллоевич",
  tarix20: "Юклаб олиш",
  tarix21: "Хўжақулов Одилжон Алишерович",
  tarix22: "Юклаб олиш",
  tarix23: "Икрамова Зулфия Тўлқиновна",
  tarix24: "Юклаб олиш",
  tarix25: "Икрамова Зулфия Тўлқиновна",
  tarix26: "Юклаб олиш",
  tarix27: "Нурмурадова Нодира Мурадуллаевна",
  tarix28: "Юклаб олиш",
  tarix29: "Расулова Муниса Мурмислимовна",
  tarix30: "Юклаб олиш",
  tarix31: "Фазилов Акрам",
  tarix32: "Юклаб олиш",
  tarix33: "Мирюсупов Мирқосим Мирсаматович",
  tarix34: "Юклаб олиш",
  tarix35: "Ниязов Азиз Набиевич",
  tarix36: "Юклаб олиш",
  tarix37: "Сипова Гўзалой Ғуломиддиновна",
  tarix38: "Юклаб олиш",



  darsTittle: "Дарс джадвали",
  darsopen: "Очиш",
  darssave: "Сақлаш",
  dars1: "Тугма нуқсонларнинг пренатал ультратовуш диагностикаси",
  dars2: "КЛИНИК УЛТРАТОВУШ ДИАГНОСТИКАСИ",
  dars3: "Акушерлик амалиётида допплерография технологиялари",
  dars4: "Клиник нейросонография",
  dars5: "Ультратовуш маммографiyasining инновасион технологиялари",


  prezidentTittle: "Президент фармонлари",

  ssvTittle: "Соғлиқни сақлаш вазирлиги буйруқлари",

  markazTittle: "Марказ буйруқлари",


  dasturTittle: "Дастурлар",
  dastur1: "Фетал экокардиография асослари",
  dastur2: "Ултратовуш маммографисида BI-RADS таснифланишининг клиник қўлланилиши",
  dastur3: "Бачадон миомасининг ультратовуш диагностикаси",
  dastur4: "Тухумдонлар ҳосилаларини ташхизлашда O-RADS таснифланишининг клиник қўлланилиши",
  dastur5: "Ургент ҳолатдаги беморларда FAST, BLUE, RUSH ультратовуш текшириш протоколларининг қўлланилиши",
  dastur6: "Клиник нейросонография",
  dastur7: "Флебологияда ультратовуш диагностикаси замонавий технологиялари",
  dastur8: "Ултратовуш диагностикаси аппаратини бошқариш тамойиллари ва экографик тасвирни мақбуллаштириш",
  dastur9: "Акушерлик амалиётида допплерография технологиялари",
  dastur10: "Фетал экокардиография: туғма юрак нуқсонлар диагностикаси",
  dastur11: "Ултратовуш маммографяси инновацион технологиялари",
  dastur12: "Клиник амалиётда ультратовуш эластография технологиялари",
  dastur13: "Туғма нуқсонларнинг пренатал ультратовуш диагностикаси",
  dastur14: "Қон-томир тизимини комплекс ультратовуш диагностикаси",
  dastur15: "Акушерлик амалиётида ультратовуш диагностикасининг танланган масалалари",
  dastur16: "Сийдик тош касаллигини ва унинг асоратларини ультратовуш диагностикаси ва даволаш усуллари",
  dastur17: "Урология амалиётида ультратовуш диагностикасининг танланган масалалари",
  dastur18: "Акушерлик амалиётида ультратовуш диагностикаси асослари",
  


  contactTittle: "Биз билан боғланиш",
  contact1: "Манзил:",
  contact2: "Тошкент ш. М.Улуғбек тумани, Паркент кўчаси, 51",
  contact3: "Алоқа рақами:",
  contact4: "Электрон почта:",
  contact5: "Иш тартиби:",
  contact6: "Вебсайт:",
  contact7: "Тушлик:",


  workingPrograms1: "Ултратовуш диагностикаси аппаратларини бошқариш тамойиллари",
  workingPrograms2: "Ултратовуш маммографиясининг инновацион технологиялари",
  workingPrograms3: "Флебологияда ултратовуш диагностикаси замонавий технологиялари",
  workingPrograms4: "Кон томир тизимини комплекс ултратовуш диагностикаси клиник",
  workingPrograms5: "Туғма нуқсонларнинг пренатал ултратовуш диагностикаси",
  workingPrograms6: "Урология амалиётида ултратовуш диагностикасининг танланган",
  workingPrograms7: "Клиник ультратовуш диагностикаси",
  workingPrograms8: "Бачадон миомасини ультратовуш диагностикаси",
  workingPrograms9: "Тухумдонлар ҳосилаларини ташхислашда O RADS таснифланишининг",
  workingPrograms10: "Ултратовуш маммографиясида BI RADS УЗД",
  workingPrograms11: "Ургент холатдаги беморларда FAST, BLUE, RUSH ултратовуш текшириш",
  workingPrograms12: "Фетал эхокардиография асослари УЗД",
  workingPrograms13: "Акушерлик амалиётида допплерография технологиялари УЗД",
  workingPrograms14: "Клиник нейросонография УЗД",
  workingPrograms15: "Клиник ултратовуш ташхислашда эластография технологияларни",
  
  siteLink1: "Ўзбекистон Рспубликаси Соғлиқни сақлаш вазирлиги",
  siteLink2: "Ўзбекистон Рспубликаси Презденти веб-сайти",
  siteLink3: "Ягона интерактив давлат хизматлари портали",

  test: "Маълумотлар тўлиқ юкланмагани сабабли сайт тест режимида ишлаяпти",


};


export default translationOz
